import { ProductJsonLd } from 'next-seo';
import type { ReactElement } from 'react';

import type { OrderAppProductVariantsBusinessDetailsQuery } from '@/graphql/orderApp/api';
import type {
  ProductVariantStrapDetailsFragment,
  ProductVariantWatchBasicDetailsFragment,
  StrapBuckleSizesQuery,
} from '@/graphql/saleor/api';
import type {
  CmsExtraDataRecord,
  ContentfulData,
} from '@/integrations/contentful';
import { Default } from '@/layouts/Default';
import type { Maybe } from '@/lib/types';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

import { StrapView } from './StrapView';

export interface StrapViewWrapperProps {
  buckleSizesData: StrapBuckleSizesQuery;
  businessData: OrderAppProductVariantsBusinessDetailsQuery;
  cmsData: ContentfulData[];
  cmsExtraDataRecord: CmsExtraDataRecord;
  data: ProductVariantWatchBasicDetailsFragment;
  draftMode: boolean;
  productVariant: Maybe<ProductVariantStrapDetailsFragment>;
}

export const StrapViewWrapper = ({
  buckleSizesData,
  businessData,
  cmsData,
  cmsExtraDataRecord,
  data,
  draftMode,
  productVariant,
}: StrapViewWrapperProps) => {
  return (
    <StrapView
      buckleSizesData={buckleSizesData}
      businessData={businessData}
      cmsData={cmsData}
      cmsExtraDataRecord={cmsExtraDataRecord}
      data={data}
      draftMode={draftMode}
      productVariant={productVariant}
    />
  );
};

StrapViewWrapper.getLayout = (page: ReactElement) => {
  return (
    <DraftModeContext.Provider value={page.props.draftMode}>
      <Default
        alertBannerHiddenOnMobile
        cmsData={page.props.cmsDefaultLayoutData}
        draftMode={page.props.draftMode}
      >
        <ProductJsonLd
          brand='Breitling'
          {...page.props.productStructuredData}
        />
        {page}
      </Default>
    </DraftModeContext.Provider>
  );
};
